import StandardContactFields from '../lib/StandardContactFields/StandardContactFields';
import StandardContactAddressSubFields from '../lib/StandardContactFields/StandardContactAddressSubFields';
import { getTextFromTranslationCode } from './multiLanguageUtils';
import { REGISTRATION_TYPE_ID_FIELD_ID, CONTACT_TYPE_ID_FIELD_ID } from '@cvent/event-fields/fieldIds';
const customContactFieldsToCheck = ['MultiChoice', 'SingleChoice'];
const getFieldIds = () => {
    const fieldIdArray = Object.keys(StandardContactFields).map(key => {
        return StandardContactFields[key].id;
    });
    fieldIdArray.push(REGISTRATION_TYPE_ID_FIELD_ID, CONTACT_TYPE_ID_FIELD_ID);
    return fieldIdArray;
};
const checkForRegTypes = visibilityLogic => {
    let regTypesPresent = false;
    visibilityLogic.filters.forEach(visibilityFilter => {
        if (visibilityFilter.fieldName) {
            if (visibilityFilter.fieldName === REGISTRATION_TYPE_ID_FIELD_ID) {
                regTypesPresent = true;
            }
        }
        else if (visibilityFilter.filters) {
            visibilityFilter.filters.forEach(innerFilter => {
                if (innerFilter.fieldName === REGISTRATION_TYPE_ID_FIELD_ID) {
                    regTypesPresent = true;
                }
            });
        }
    });
    return regTypesPresent;
};
const evaluateRegTypeCriteria = (criteria, regTypes) => {
    let validRegTypes = true;
    criteria.forEach(criterion => {
        // eslint-disable-next-line no-prototype-builtins
        if (!regTypes.hasOwnProperty(criterion.value)) {
            validRegTypes = false;
        }
    });
    return validRegTypes;
};
const evaluateCustomContactCriteria = (filter, customContactField, isFlexMultiLangVisibilityRulesEnabled) => {
    const customContactChoices = customContactField.question.questionTypeInfo.choices;
    const customContactValues = [];
    const cleanedValues = [];
    customContactChoices.forEach(contactChoice => {
        let choiceText = contactChoice.text;
        if (isFlexMultiLangVisibilityRulesEnabled) {
            choiceText = getTextFromTranslationCode(contactChoice.text);
        }
        customContactValues.push(choiceText);
    });
    filter.values.forEach(criteria => {
        if (customContactValues.includes(criteria.value)) {
            cleanedValues.push(criteria);
        }
    });
    return Object.assign(Object.assign({}, filter), { values: cleanedValues });
};
const cleanFilters = (question, regTypes, customContactFields, isFlexMultiLangVisibilityRulesEnabled) => {
    const shouldKeepRegTypeCriteria = checkForRegTypes(question.visibilityLogic);
    const cleanedFilters = [];
    const displayExpression = question.visibility.questionVisibilityLogic.displayExpression;
    const fieldIds = getFieldIds();
    displayExpression.filters.forEach(visibilityFilter => {
        if (fieldIds.includes(visibilityFilter.fieldId) ||
            // eslint-disable-next-line no-prototype-builtins
            customContactFields.hasOwnProperty(visibilityFilter.fieldId) ||
            // eslint-disable-next-line no-prototype-builtins
            StandardContactAddressSubFields.hasOwnProperty(visibilityFilter.fieldId)) {
            if (visibilityFilter.fieldId === REGISTRATION_TYPE_ID_FIELD_ID) {
                if (shouldKeepRegTypeCriteria && evaluateRegTypeCriteria(visibilityFilter.values, regTypes)) {
                    cleanedFilters.push(visibilityFilter);
                }
            }
            else if (
            // eslint-disable-next-line no-prototype-builtins
            (customContactFields === null || customContactFields === void 0 ? void 0 : customContactFields.hasOwnProperty(visibilityFilter.fieldId)) &&
                customContactFieldsToCheck.includes(customContactFields[visibilityFilter.fieldId].question.questionTypeInfo.questionType)) {
                cleanedFilters.push(evaluateCustomContactCriteria(visibilityFilter, customContactFields[visibilityFilter.fieldId], isFlexMultiLangVisibilityRulesEnabled));
            }
            else {
                cleanedFilters.push(visibilityFilter);
            }
        }
    });
    return Object.assign(Object.assign({}, displayExpression), { filters: cleanedFilters });
};
export function transformVisibilityLogicEventData(question, regTypes = {}, customContactFields = {}, isFlexMultiLangVisibilityRulesEnabled = false) {
    // if present, persist existing visibility results
    return Object.assign(Object.assign({}, question), { question: Object.assign(Object.assign({}, question.question), { visibility: {
                questionVisibilityLogic: {
                    displayExpression: cleanFilters(question.question, regTypes, customContactFields, isFlexMultiLangVisibilityRulesEnabled)
                }
            } }) });
}
